import React, { Component } from "react";
import { Button } from "devextreme-react";
import ReportForm from "components/AdminComponents/ReportForm";

export default class MailReportGenerator extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showPopup: false,
      investors_list: null,
      startups_list: null,
    };
    this.togglePopup = () => {
      this.setState({ showPopup: !this.state.showPopup });
    };
  }
  componentDidMount() {
    this.setState({
      investors_list: this.props.investors_list,
      startups_list: this.props.startups_list,
    });
  }

  render() {
    return (
      <>
        <Button text="Generate report" onClick={this.togglePopup} />
        {this.state.showPopup ? <ReportForm store={true} /> : null}
      </>
    );
  }
}
